import { useSettings } from "@/context/SettingsContext";
import { buildWhatsappUrl, track } from "@/lib/api";
import { Phone, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import InquiryDialog from "@/components/InquiryDialog";

export default function CTAButtons({ label = "", sourceRef, prefill, dark = false, testIdPrefix = "cta" }) {
  const { settings } = useSettings();
  const phone = settings?.phone_primary;
  const wa = settings?.whatsapp_number || "+919866933180";

  const message = prefill || `Hello! I'm interested in ${label || "your travel services"}.`;
  const waUrl = buildWhatsappUrl(wa, message);

  return (
    <div className="flex flex-wrap items-center gap-3">
      {phone && (
        <a
          href={`tel:${phone}`}
          onClick={() => track("call_click", sourceRef)}
          data-testid={`${testIdPrefix}-call-btn`}
          className={`inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium border transition-colors ${
            dark
              ? "border-white/30 text-white hover:bg-white hover:text-slate-950"
              : "border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white"
          }`}
        >
          <Phone className="w-4 h-4" /> Call Now
        </a>
      )}
      <a
        href={waUrl}
        target="_blank"
        rel="noreferrer"
        onClick={() => track("whatsapp_click", sourceRef)}
        data-testid={`${testIdPrefix}-whatsapp-btn`}
        className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-medium bg-[#25D366] text-white hover:bg-[#1ebe57]"
      >
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </a>
      <InquiryDialog defaultMessage={message} sourceRef={sourceRef} triggerTestId={`${testIdPrefix}-inquiry-btn`}>
        <Button className={`rounded-full px-5 py-3 text-sm font-medium ${dark ? "bg-amber-400 text-slate-950 hover:bg-amber-300" : "bg-slate-950 text-white hover:bg-slate-800"}`} data-testid={`${testIdPrefix}-inquiry-btn`}>
          Send Inquiry
        </Button>
      </InquiryDialog>
    </div>
  );
}
